export default "__VITE_PUBLIC_ASSET__4f315ec3__"